export function getLocalDateFromUTCDate(date) {
    date = date instanceof Date ? date : new Date(date);
    // Be sure to account for timezone offset
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    return date;
};

export function toMMddYYYY(date) {
    let res = null;
    if (typeof date === 'string') {
        date = getLocalDateFromUTCDate(new Date(date));
    }

    if (date instanceof Date) {
        res = date.toLocaleDateString('en-US');
    }

    return res;
}

export function toIsoDateString(date) {
    // Remove the timestamp from date string
    return date.toISOString().substring(0, 10);
}

export function formatISODate(date) {
    let formattedDate = "";
    if (date) {
        formattedDate = new Date(date).toLocaleString();
        formattedDate = formattedDate.replaceAll("/", "-");
    }
    return formattedDate;
}

export function toDateTimeString(date) {
    // Return date and time as '3/2/2022 8:52:03 AM'
    date = date instanceof Date ? date : new Date(date);
    let dateString = date.toLocaleString();
    return dateString.replace(',', '');
}

export function toDateString(date) {
    // Return date as '3/2/2022'
    date = date instanceof Date ? date : new Date(date);
    return date.toLocaleDateString();
}

export function getBeginningOfDay(date) {
    let d = (date) ? new Date(date) : new Date();
    d.setHours(0, 0, 0, 0);
    return d;
}

export function getEndOfDay(date) {
    let d = (date) ? new Date(date) : new Date();
    d.setHours(23, 59, 59, 999);
    return d;
}

export function DateRange(start, end) {
    return { startOn: start, endOn: end };
}

export function getPastXDays(numberOfDays) {
    const currentDate = getEndOfDay();

    let beginningDate = new Date(currentDate);
    beginningDate.setDate(beginningDate.getDate() - numberOfDays);

    return new DateRange(beginningDate, currentDate);;
}

export function getCurrentWeekDateRange() {
    const currentDate = getBeginningOfDay();
    const dayOfWeek = currentDate.getDay();

    let sunday = new Date(currentDate)
    sunday.setDate(sunday.getDate() - dayOfWeek);

    return new DateRange(sunday, getEndOfDay());
}

export function getCurrentMonthDateRange() {
    const currentDate = getBeginningOfDay();
    let firstOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

    return new DateRange(firstOfMonth, getEndOfDay());
}

export function getCurrentQuarterDateRange() {
    const monthOfQuarterStarts = [0, 3, 6, 9];
    const currentDate = getBeginningOfDay();

    // Determine current quarter. This is used as an index to the above array.
    const currentQuarter = Math.floor(currentDate.getMonth() / 3);

    let firstDateInQuarter = new Date(currentDate.getFullYear(), monthOfQuarterStarts[currentQuarter], 1);

    return new DateRange(firstDateInQuarter, getEndOfDay());
}